export default {"src":"/_next/static/media/img-gov-online.ee666524.svg","height":61,"width":160,"blurWidth":0,"blurHeight":0};